<footer class="footer_bg">
  <p>© Z.E.N Classics {{currentYear}}</p>
  <p>Read our <a (click)="privacyClick()" class="terms">Privacy Policy</a> and <a (click)="termsClick()" class="terms">Terms & Conditions</a></p>
  <ul>
    <li><a href="https://www.facebook.com/zenclassics/" target="_blank"><img src="assets/images/facebook.png" title="Facebook"></a></li>
    <li><a href="https://www.instagram.com/zenclassics/" target="_blank"><img src="assets/images/instagram.png" title="Instagram"></a></li>
    <li><a href="https://twitter.com/zenclassics" target="_blank"><img src="assets/images/twitter.png" title="Twitter"></a></li>
    <li><a href="https://www.pinterest.com/zenclassics/" target="_blank"><img src="assets/images/pinterest.png" title="Pinterest"></a></li>
  </ul>
</footer>



// WEBPACK FOOTER //
// ./src/app/template/footer/footer.component.html